"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Screen = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Adrian Kluska <adrian.kluska@movecloser.pl>
 */
let Screen = class Screen extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.isOffScreen = false;
        this.isOpen = false;
    }
    open() {
        this.isOpen = true;
        if (typeof window === 'undefined' ||
            (this.$el.getBoundingClientRect().height > window.innerHeight)) {
            this.isOffScreen = true;
        }
    }
};
__decorate([
    vue_property_decorator_1.Prop({ type: Boolean, required: false, default: false }),
    __metadata("design:type", Boolean)
], Screen.prototype, "delayed", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Boolean, required: false, default: false }),
    __metadata("design:type", Boolean)
], Screen.prototype, "hideOnLoading", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Boolean, required: false, default: false }),
    __metadata("design:type", Boolean)
], Screen.prototype, "loading", void 0);
Screen = __decorate([
    vue_property_decorator_1.Component({
        name: 'Screen',
        mounted() {
            this.$nextTick(() => {
                if (this.delayed) {
                    setTimeout(this.open, 250);
                }
                else {
                    this.open();
                }
            });
        },
        beforeDestroy() {
            this.isOpen = false;
        },
        template: `
    <div class="screen" :class="{ '--off-screen': isOffScreen, '--open': isOpen || !delayed, '--hidden': hideOnLoading }">
      <slot v-if="!(hideOnLoading && loading)" />
      <div v-if="loading" class="screen__overlay">
        <div class="screen__overlay__spinner" />
      </div>
    </div>
  `
    })
], Screen);
exports.Screen = Screen;
//# sourceMappingURL=Screen.js.map